import { useState, useEffect } from 'react';
import { IconMail, IconMailOpened } from '@tabler/icons-react';
import { fetchContactMessages, setMessageRead } from '../lib/forms';
import { showToast } from '../components/ui/Toast';

function niceDateTime(iso) {
  return new Date(iso).toLocaleString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
    timeZone: 'America/Guyana'
  });
}

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchContactMessages().then(res => {
      if (cancelled) return;
      setMessages(res.messages);
      setLoadError(res.error);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  async function mark(m, read) {
    if (busy) return false;
    setBusy(true);
    const res = await setMessageRead(m.id, read);
    setBusy(false);
    if (res.error) {
      showToast(res.error, 'error');
      return false;
    }
    setMessages(list => list.map(x => (x.id === m.id ? { ...x, read } : x)));
    return true;
  }

  async function toggleOpen(m) {
    if (openId === m.id) { setOpenId(null); return; }
    setOpenId(m.id);
    if (!m.read) await mark(m, true);
  }

  if (loading) return <p className="adm-sub">Loading messages...</p>;

  const unread = messages.filter(m => !m.read).length;

  return (
    <div>
      <h1 className="adm-title">Messages</h1>
      <p className="adm-sub">
        Messages sent from the Contact page. {unread > 0 ? unread + ' unread.' : 'Nothing unread.'} Click a message to read it; to answer, use the Reply link.
      </p>

      <div className="adm-card">
        {loadError && <p style={{ fontSize: 12, color: '#8B2020' }}>{loadError}</p>}
        {!loadError && messages.length === 0 && (
          <p style={{ fontSize: 12, color: '#888' }}>No messages yet.</p>
        )}
        {messages.map(m => {
          const open = openId === m.id;
          return (
            <div key={m.id} style={{ borderBottom: '1px solid rgba(74,46,26,0.06)', padding: '10px 0' }}>
              <button
                type="button"
                onClick={() => toggleOpen(m)}
                aria-expanded={open}
                style={{ all: 'unset', cursor: 'pointer', display: 'flex', gap: 10, alignItems: 'center', width: '100%' }}
              >
                {m.read ? <IconMailOpened size={16} color="#888" /> : <IconMail size={16} color="#4A2E1A" />}
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span style={{ fontSize: 13, fontWeight: m.read ? 400 : 700 }}>{m.name}</span>
                  <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>{m.category || 'No topic'}</span>
                  {!m.read && <span style={{ fontSize: 10, marginLeft: 8, color: '#8B2020', fontWeight: 600 }}>NEW</span>}
                </span>
                <span style={{ fontSize: 11, color: '#888' }}>{niceDateTime(m.created_at)}</span>
              </button>
              {open && (
                <div style={{ marginTop: 10, paddingLeft: 26 }}>
                  <p style={{ fontSize: 12, color: '#666', margin: '0 0 4px' }}>
                    {m.email}{m.order_number ? ' · Order ' + m.order_number : ''}
                  </p>
                  <p style={{ fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-wrap', margin: '0 0 10px' }}>{m.message}</p>
                  <a
                    className="adm-btn"
                    style={{ fontSize: 11, padding: '4px 10px', marginRight: 8, textDecoration: 'none', display: 'inline-flex', width: 'auto' }}
                    href={'mailto:' + encodeURIComponent(m.email) + '?subject=' + encodeURIComponent('Re: your message to Andre M Leather')}
                  >
                    Reply
                  </a>
                  <button className="adm-btn adm-btn--outline" disabled={busy} style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => mark(m, false)}>
                    Mark as unread
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
